import React, { useEffect } from 'react'
import { useCardContext } from 'src/components/Card/CardContext'
import { useStaffingAgencyDetailsById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const staffingAgency = useStaffingAgencyDetailsById(id)
  const status = staffingAgency?._status
  const cardContext = useCardContext()
  useEffect(() => {
    if (typeof status?.name === 'string' && typeof status?.color === 'string') {
      cardContext.setColor(status.color)
    }
  }, [status])
  return (
    <h2 className='text-uppercase fw-bold'>{status?.name}</h2>
  )
}

export default Body
